var map = {
	"./notice0.png": "gRx4",
	"./notice1.png": "QarF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uphX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/notice.*\.png$
// module id = uphX
// module chunks = 3